import request from '@/utils/request'

/**
 * 查询家政服务费用配置
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServConfig(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeConfig.queryHousekeepingServConfig',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询工单费用
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryStoreOrderCartFee(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrderCartFee',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 完成家政服务工单
 * @param {Object} data 提交数据
 * @returns {Promise} Promise对象
 */
export function housekeepingServPoolFinish(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeeping.servPoolFinish',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}